// extracted by mini-css-extract-plugin
export default {"form":"ConnectNetSuiteForm_form__q3UGD","mandatory":"ConnectNetSuiteForm_mandatory__igYKV","footer":"ConnectNetSuiteForm_footer__Ziy3K","button":"ConnectNetSuiteForm_button__Yv+9v"};